<script setup>
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router/composables'
import PmSummaryForm from './Form.vue'

const route = useRoute()
const router = useRouter()

const editId = computed(() => parseInt(route.params.id, 10))

const goBack = () => router.push({ name: 'preventive-maintenance.summary' })
</script>

<template>
  <div class="pm-summary-edit-page">
    <div class="page-header">
      <v-btn icon small @click="goBack">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <span class="page-title">Edit PM Summary</span>
    </div>

    <PmSummaryForm wide :edit-id="editId" @on-success="goBack" @on-cancel="goBack" />
  </div>
</template>

<style lang="sass" scoped>
.pm-summary-edit-page
  display: flex
  flex-direction: column
  gap: 16px
  padding: 4px 0

  .page-header
    display: flex
    align-items: center
    gap: 8px

    .page-title
      font-size: 16px
      font-weight: 600
      color: #333
</style>

<script>
export default {
  name: 'PmSummaryEditPage',
}
</script>
